module.exports = __webpack_public_path__ + "files/173682cef105829829a008f1fc97e980.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/favicon-96x96.png
// module id = 1850
// module chunks = 59